module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAiBAMAAAAZjhKBAAAAD1BMVEUAAAAzMzMzMzMzMzMzMzNw57/sAAAABHRSTlMAEJ/PUreMHgAAADdJREFUOMtjYMAOGI0YCAAmFwUCKhhNnAgZIjxqyCA3xIUAcCJCBYVOJezSUSMGmxFElA7wEgYAByUfu+nBXwMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/images/arrows/cursor-right-dark-2x.png
// module id = ../../../../../src/assets/images/arrows/cursor-right-dark-2x.png
// module chunks = styles